<template>
  <cv-content id="main-content" style="max-width: 1200px;">
    <cv-grid>
      <cv-row>
        <cv-column :sm="4" :md="3" :lg="6">
          <data-valida etichetta="Dalla Data"
                       v-model="parametri.dalla_data"
                       messaggio_non_valido="Data iniziale non valida" />
        </cv-column>
        <cv-column :sm="4" :md="3" :lg="6">
          <data-valida etichetta="Alla Data"
                       v-model="parametri.alla_data"
                       messaggio_non_valido="Data finale non valida" />
        </cv-column>
        <cv-column :sm="4" :md="2" :lg="4">
          <cv-text-input label="Anno" value="2021" />
        </cv-column>
      </cv-row>
      <cv-row>
        <cv-column :sm="4" :md="8" :lg="16">
          <cv-combo-box label=""
                        title="Cliente" :auto-filter="true"
                        value=""
                        :options="clienti"></cv-combo-box>
        </cv-column>
      </cv-row>
      <cv-row>
        <cv-column :sm="4" :md="4" :lg="8">
          <cv-tile style="margin-top: 0.5em; margin-bottom: 0.5em;">
            <h6>Tipo di Stampa</h6>
            <cv-radio-group :vertical="true" @change="tipoSelezionato"
                            title="Tipo di Pagamento" >
              <cv-radio-button name="tipo"
                               label="Fattura Completa"
                               value="1"
                               v-model="modello_tipo_stampa" />
              <cv-radio-button name="tipo"
                               label="Lista Semplice"
                               value="2"
                               v-model="modello_tipo_stampa" />
            </cv-radio-group>
          </cv-tile>
        </cv-column>
        <cv-column :sm="4" :md="4" :lg="8">
          <cv-tile style="margin-top: 0.5em; margin-bottom: 0.5em;">
            <h6>Includere</h6>
            <cv-radio-group :vertical="true" ena
                            title="Includere">
              <cv-radio-button name="incl"
                               :disabled="flg_inclusione"
                               label="Tutte"
                               value="1"
                               v-model="modello_inclusione" />
              <cv-radio-button name="incl"
                               :disabled="flg_inclusione"
                               label="Solo Da Riscuotere"
                               value="2"
                               v-model="modello_inclusione" />
              <cv-radio-button name="incl"
                               :disabled="flg_inclusione"
                               label="Solo Già Riscosse"
                               value="3"
                               v-model="modello_inclusione" />
            </cv-radio-group>
          </cv-tile>
        </cv-column>
      </cv-row>
    </cv-grid>
    <hr/>
    <BottonieraRicerche v-on:filtra-premuto="$emit('bottone-premuto')"
                        v-on:pdf-premuto="$emit('bottone-premuto')" />
  </cv-content>
</template>

<script>
import BottonieraRicerche from "@/components/BottonieraRicerche";

export default {
  name: "RicercaFatture",
  components: { BottonieraRicerche },
  data: function() {
    return {
      parametri: {
        dalla_data: "",
        alla_data: ""
      },
      modello_tipo_stampa: "1",
      modello_inclusione: "1",
      flg_inclusione: false,
      clienti: [
        {
          value: "1",
          label: "Azienda Agricola Mario Rossi s.r.l",
          name: "1"
        },
        {
          value: "2",
          label: "Paolo Verdi s.r.l",
          name: "2"
        }
      ]
    }
  },
  methods: {
    tipoSelezionato: function (evt) {
      console.log(evt);
      this.flg_inclusione = (evt === '2');
    }
  }
}
</script>

<style scoped>

</style>